export const WIZARD_INDENTIFIERS = {
	GroomingAppointment: 'grooming_appointment',
	GroomingProfile: 'grooming_profile',
	DaycareAppointment: 'daycare_appointment',
	BoardingAppointment: 'boarding_appointment'
}

export const WIZARD_SCREEN_TYPES = {
	Start: 'start',
	Intro: 'intro',
	Form: 'form',
	Exit: 'exit',
	Invoice: 'invoice',
	Final: 'final'
}

export const NAVIGATION_DIRECTIONS = {
	Backward: 0,
	Forward: 1
}
